/*
 * !
 *  * Copyright (c) Pro3W 2024
 *  * author: Sławomir Moskal
 *  * project: dev.cms.pro3w.pl
 *  * filename: js_body_start.js
 *  * last update: 25.01.2024, 22:13
 *
 */

import "js-cookie";

import Cookies from "js-cookie";
//import * as Cookies from 'js-cookie';
global.Cookies = Cookies;

// import "vanilla-cookieconsent";
import A11yDialog from 'a11y-dialog';

window.A11yDialog = A11yDialog;

import * as CookieConsent from 'vanilla-cookieconsent';

window.CookieConsent = CookieConsent;

// import imagesLoaded from 'imagesloaded';
//
// global.imagesLoaded = imagesLoaded;
//
// import Masonry from 'masonry-layout';
//
// global.Masonry = Masonry;
//
// import Isotope from 'isotope-layout';
//
// global.Isotope = Isotope;